export default (api) => {
    return {
        get: (wow_moment_id, options) => api.get(`wow_moments/${wow_moment_id}`, options),
        post: (options) => api.post('wow_moments', options),
        put: (wow_moment_id, options) => api.put(`wow_moments/${wow_moment_id}`, options),
        challenge: (challenge_code_id, options) => api.get(`wow_moments/challenge/${challenge_code_id}`, options),
        lesson: (lesson_id, options) => api.get(`wow_moments/lesson/${lesson_id}`, options)
    }
}
